import { KazooError } from "@kazoohr/types";

/**
 * It throws an error if the array is NOT empty
 */
export function assertIsEmpty<T>(
  array: T[],
  errorFactory: AssertIsEmptyErrorFactory<T> = (array) => {
    throw new KazooError("Array must be empty.", { array });
  }
) {
  if (array.length) {
    throw errorFactory(array);
  }
}

export type AssertIsEmptyErrorFactory<T> = (array: T[]) => KazooError;
